<!-- main app container -->
<div class="modal-header">
    <h4 class="modal-title fw-bold" id="createLotHeader" jhiTranslate="inventoryManagerApp.lot.create.title">Create lot</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
            (click)="clear()">
    </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row">
            <label for="gid" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.gid">GID</label>
            <div class="col-4">
                <input type="number" class="form-control" pattern="^[\d]+([\d]+)*$" name="gid" id="gid"
                       [(ngModel)]="lot.gid" #gid="ngModel"
                       [ngClass]="{ 'is-invalid': f.submitted && gid.invalid }"
                       min="1"
                       max="2147483647"
                       required/>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="stockIdPrefix" class="col-4 col-form-label">
                <span jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix">Stock ID Prefix</span>
                <i class="fa fa-info-circle col-1 help-icon ms-3" data-bs-toggle="tooltip" data-bs-placement="top" ngbTooltip="{{ 'inventoryManagerApp.lot.create.field.stock.id.title' | translate }}"></i>
            </label>
            <div class="col-4">
                <input type="text" jhi-stockIdPrefixValidator  class="form-control" name="stockIdPrefix" id="stockIdPrefix" [(ngModel)]="model.stockIdPrefix" #stockIdPrefix="ngModel">
                <div class="invalid-feedback d-block" *ngIf="stockIdPrefix.invalid">
                    <small jhiTranslate="inventoryManagerApp.lot.create.field.stock.id.prefix.error"></small>
                </div>
            </div>
        </div>

        <div class="mb-3 row">
            <label class="col-4">
                <label class="form-check-label" jhiTranslate="inventoryManagerApp.lot.locationName">
                    Storage Location
                </label>
            </label>
            <div class="col-4">
                <jhi-storage-locations-select [(value)]="storageLocationId"></jhi-storage-locations-select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="dropdownUnits" class="col-4" jhiTranslate="inventoryManagerApp.lot.unitName">Units</label>
            <div class="col-4">
                <select class="form-select" name="dropdownUnits" id="dropdownUnits" [(ngModel)]="lot.unitId" required="{{initialDeposit}}" #dropdownUnits="ngModel" (change)="unitChanged()">
                    <option *ngFor="let unit of units | async" [value]="unit.id">
                        <label>{{unit.name}}</label>
                    </option>
                </select>
            </div>
        </div>
        <div class="mb-3 row">
            <label for="lotNotes" class="col-4" jhiTranslate="inventoryManagerApp.lot.notes">Notes</label>
            <div class="col-4">
                <textarea class="form-control" rows="3" name="lotNotes" id="lotNotes" [(ngModel)]="lot.notes" #lotNotes="ngModel" jhi-forbiddenCharactersValidator></textarea>
            </div>
        </div>
        <div *jhiHasAnyAuthority="CREATE_DEPOSIT_INVENTORY_PERMISSION">
            <div class="mb-3 row" style="margin-bottom: 0px;">
                <h4 class="modal-title fw-bold col-4" id="myDepositLabel" jhiTranslate="inventoryManagerApp.lot.create.field.deposit">Deposit</h4>
            </div>
            <div class="mb-3 row">
                <label class="col-4 col-form-label">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" [(ngModel)]="initialDeposit" name="depositAvailable" id="depositAvailable">
                        <label class="form-check-label" for="depositAvailable" jhiTranslate="inventoryManagerApp.lot.create.field.initial.deposit">
                            Initial deposit
                        </label>
                    </div>
                </label>
            </div>
            <div class="border-top my-3">
            </div>
            <br>
            <div *ngIf="!isSeedAmountUndefined">
                <div class="mb-3 row" [ngStyle]="{'margin-bottom': depositAmount.touched && depositAmount.invalid ? '0px':'16px'}">
                    <label for="depositAmount" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.create.field.amount">Amount</label>
                    <div class="col-4">
                        <input type="number" class="form-control" name="depositAmount" id="depositAmount" [disabled]="!initialDeposit"
                               [(ngModel)]="deposit.amount" jhi-customMinGreaterThanValidator min=0 #depositAmount="ngModel"
                               [ngClass]="{ 'is-invalid': f.submitted && depositAmount.invalid }" required="{{initialDeposit}}"/>
                        <div [hidden]="!(depositAmount.touched && depositAmount.invalid)">
                            <small class="invalid-feedback d-block" jhiTranslate="inventoryManagerApp.lot.create.field.amount.note">
                                Initial amount must be higher than zero
                            </small>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isSeedAmountUndefined">
                <div class="mb-3 row">
                    <label for="undefinedDepositAmount" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.create.field.amount">Amount</label>
                    <div class="col-4">
                        <input type="number" class="form-control" name="undefinedDepositAmount" id="undefinedDepositAmount" [disabled]="true"
                               [(ngModel)]="deposit.amount" #undefinedDepositAmount="ngModel"/>
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <label for="depositNotes" class="col-4 col-form-label" jhiTranslate="inventoryManagerApp.lot.notes">Notes</label>
                <div class="col-4">
                    <textarea class="form-control" rows="3" name="depositNotes" id="depositNotes" [disabled]="!initialDeposit" [(ngModel)]="deposit.notes" #depositNotes="ngModel" jhi-forbiddenCharactersValidator></textarea>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="entity.action.cancel">Cancel</span>
    </button>
    <button (click)="save()" [disabled]="f.form.invalid || isInvalid()" class="btn btn-primary" data-test="createLotsButton">
        <span class="fa fa-save"></span>&nbsp;<span jhiTranslate="entity.action.save">Save</span>
    </button>
</div>
